import { businessStore, userStore } from '../stores';
import { apiRequest } from '../utils/useAPIRequest';
import constant from '../utils/constant';
import { Data, IControllerResponseDTO, ISubscriptionDTO } from '@/interfaces';

const getAllSubscriptions = async (planQuery: any): Promise<IControllerResponseDTO> => {
  const { status, data, errorMessage } = await apiRequest<Data>({
    url: `/subscriptions/plans?${planQuery}`,
    method: 'get',
  });
  const subData = (data || {}) as ISubscriptionDTO[];

  if (status === constant.Success) {
    businessStore.setSubscriptionPlans(subData);
    return { status: constant.Success };
  }
  return { errorMessage, status };
};

const uploadDocument = async (payload: any): Promise<IControllerResponseDTO> => {
  const { status, errorMessage, data } = await apiRequest<Data>({
    url: "/businesses/documents/upload",
    method: "post",
    payload,
    hasImageUpload: true,
  });
  if (status === constant.Success) {
    return { status: constant.Success, data };
  }
  return { errorMessage, status, data };
};

const BusinessController = {
  getAllSubscriptions,
  uploadDocument,
};

export default BusinessController;
